// Types
import { LayoutBuilderHandlersType, LayoutMethodsHandlersType } from './types/layout.handlers.type';
// Utils
import { getLayoutScreenDetailsErrorByState } from './utils/layout.handlers.utils';

const fetchFlowInitialDataHandler = async ({
  currentState,
  fetchResolver,
  setCurrentStep,
  setFetching,
  setFlowApiData,
  setError,
  setMaxSteps,
  setRenderChildren,
}: Omit<LayoutBuilderHandlersType, 'setShowModal'>): Promise<void> => {
  setFetching(true);

  const [response, error] = await fetchResolver();

  if (error) {
    setError(getLayoutScreenDetailsErrorByState(currentState));
  } else {
    const { steps, ...restResponse } = response;

    steps?.current && setCurrentStep(steps.current);
    steps?.total && setMaxSteps(steps.total);
    setFlowApiData(restResponse);
    setFetching(false);
    setRenderChildren(true);
  }
};

const LayoutHandlers = (props: LayoutBuilderHandlersType): LayoutMethodsHandlersType => ({
  handleFetchFlowInitialDataEvent: () => fetchFlowInitialDataHandler(props),
});

export { LayoutHandlers };
